import { Tutorials } from '../modal';
import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';

export default function reducer(state: Tutorials = new Tutorials(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.GET_TUTORIALS_MGMT_REQUEST:
      return {
        ...state,
        loadingInProgressTutorial: false,
        loadingInProgress: true,
      };
    case ActionTypes.GET_TUTORIALS_MGMT_SUCCESS:
      return {
        ...state,
        loadingInProgressTutorial: false,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.GET_TUTORIALS_MGMT_ERROR:
      return {
        ...state,
        loadingError: true,
        loadingInProgressTutorial: false,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.CREATE_TUTORIALS_MGMT_REQUEST:
      return {
        ...state,
        loadingInProgressTutorial: true,
        data: null,
      };
    case ActionTypes.CREATE_TUTORIALS_MGMT_SUCCESS:
      return {
        ...state,
        loadingInProgressTutorial: false,
        loadingSuccessTutorial: true,
        data: payload,
      };
    case ActionTypes.CREATE_TUTORIALS_MGMT_ERROR:
      return {
        ...state,
        loadingInProgressTutorial: false,
        loadingSuccessTutorial: false,
        loadingErrorTutorial: true,
        data: payload,
      };
    case ActionTypes.DELETE_TUTORIALS_MGMT_REQUEST:
      return {
        ...state,
        loadingInProgressTutorial: true,
        data: null,
      };
    case ActionTypes.DELETE_TUTORIALS_MGMT_SUCCESS:
      return {
        ...state,
        loadingInProgressTutorial: false,
        loadingSuccessTutorial: true,
        data: payload,
      };
    case ActionTypes.DELETE_TUTORIALS_MGMT_ERROR:
      return {
        ...state,
        loadingInProgressTutorial: false,
        loadingSuccessTutorial: false,
        loadingErrorTutorial: true,
        data: payload,
      };
    default:
      return state;
  }
}
